import { search } from '../../utils';

import {
  SEARCH_BLUR,
  SEARCH_FOCUS,
  UPDATE_SEARCH_TERM,
  SEARCH_KEYBOARD_UP,
  SEARCH_KEYBOARD_DOWN,
  SEARCH_KEYBOARD_ENTER,
} from '../actionTypes';

export function onBlurSearch() {
  return {
    type: SEARCH_BLUR,
  };
}

export function onFocusSearch() {
  return {
    type: SEARCH_FOCUS,
  };
}

export function onUpdateSearchTerm({ term }) {
  const results = search({ term });

  return {
    type: UPDATE_SEARCH_TERM,
    results,
    term,
  };
}

export function onSearchKeyboardUp() {
  return {
    type: SEARCH_KEYBOARD_UP,
  };
}

export function onSearchKeyboardDown() {
  return {
    type: SEARCH_KEYBOARD_DOWN,
  };
}

export function onSearchKeyboardEnter() {
  return {
    type: SEARCH_KEYBOARD_ENTER,
  };
}
